import { FC, useEffect } from 'react';
import {
  Box,
  Container,
  IconButton,
  InputAdornment,
} from '@mui/material';
import PageGrid from 'components/PageGrid';
import { observer } from "mobx-react"
import store from "./store"
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import PopupGrid from 'components/PopupGrid';
import OrganizationPopupForm from './../OrganisationAddEditView/popupForm';
import CustomTextField from 'components/TextField';
import CustomButton from 'components/Button';
import ClearIcon from "@mui/icons-material/Clear";
import layout_store from "../../../layouts/MainLayout/store";


type OrganizationListViewProps = {};


const OrganizationListView: FC<OrganizationListViewProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    store.loadOrganizations()
    return () => {
      store.clearStore()
    }
  }, [])

  const columns: GridColDef[] = [
    {
      field: 'organization_code',
      headerName: translate("label:OrganizationListView.organization_code"),
      flex: 1
    },
    {
      field: 'name',
      headerName: translate("label:OrganizationListView.name"),
      flex: 2
    },
    {
      field: 'short_name',
      headerName: translate("label:OrganizationListView.short_name"),
      flex: 1
    },
    {
      field: 'organization_type',
      headerName: translate("label:OrganizationListView.organization_type"),
      flex: 1
    },
    {
      field: 'inn',
      headerName: translate("label:OrganizationListView.inn"),
      flex: 1
    },
    {
      field: 'phone',
      headerName: translate("label:OrganizationListView.phone"),
      flex: 1
    },
    {
      field: 'email',
      headerName: translate("label:OrganizationListView.email"),
      flex: 1
    },
    {
      field: 'is_active',
      headerName: translate("label:OrganizationListView.is_active"),
      flex: 1,
      renderCell: (params) => {
        return params.value ? translate("common:active") : translate("common:inactive");
      }
    },
  ];

  let type1: string = 'form';
  let component = null;
  switch (type1) {
    case 'form':
      component = <PageGrid
        title={translate("label:OrganizationListView.entityTitle")}
        onDeleteClicked={(id: number) => store.deleteOrganization(id)}
        columns={columns}
        data={store.data}
        hideActions={!layout_store.isSuperAdmin}
        hideAddButton={!layout_store.isSuperAdmin}
        tableName="Organization" />
      break
    case 'popup':
      component = <PopupGrid
        title={translate("label:OrganizationListView.entityTitle")}
        onDeleteClicked={(id: number) => store.deleteOrganization(id)}
        onEditClicked={(id: number) => store.onEditClicked(id)}
        columns={columns}
        data={store.data}
        hideActions={!layout_store.isSuperAdmin}
        hideAddButton={!layout_store.isSuperAdmin}
        tableName="Organization" />
      break
  }


  return (
    <Container maxWidth='xl' style={{ margin: 30 }}>
      {component}


      <OrganizationPopupForm
        openPanel={store.openPanel}
        id={store.currentId}
        onBtnCancelClick={() => store.closePanel()}
        onSaveClick={() => {
          store.closePanel()
          store.loadOrganizations()
        }}
      />

    </Container>
  );
})




export default OrganizationListView

